<template>
  <div style="min-height: 32px;">
    <div
      v-for="(item, index) in dateList"
      @click="chooseDate(item, index)"
      :class="{'date-item': true, 'date-on': tabOn === index, 'date-disable': item.expiredFlag || item.sellOutFlag}">
<!--      {{ item.periodName }} ({{item.beginTime}}-{{item.endTime}}) 余票 {{item.resouceCount}}-->
      <!-- {{ item.periodName }} (余票 {{item.resouceCount}}) -->
      {{ item.playPeriodDisplay }} (已售 {{item.maxResourceCount - item.resourceCount < 0 ? 0 : item.maxResourceCount - item.resourceCount}})
    </div>
  </div>
</template>

<script>
  import moment from 'moment'
  export default {
    name: 'x-time',
    props: ['val', 'dateList', 'currentTime'],
    data () {
      return {
        tabOn: -1
      }
    },
    watch: {
      val: {
        deep: true,
        handler (newVal, oldVal) {
          if (!newVal) {
            this.tabOn = -1
            this.$emit('timeChange', '')
          } else {
            if (!oldVal) {
              this.dateList.find((item, index) => {
                if (item.code == newVal) {
                  this.tabOn = index
                }
              })
            }
          }
        }
      }
    },
    created() {
      console.log(this.dateList)
      console.log(this.currentTime)
    },
    methods: {
      handleDate (date) {
        moment.locale('cn')
        let str = moment(date).format("MMM Do")
        return str
      },
      chooseDate (item, index) {
        if (!item.expiredFlag && !item.sellOutFlag) {
          this.tabOn = index
          this.$emit('timeChange', item.code)
        }
      },
      inputChange (event) {
        this.$emit('communication', event)
      }
    }
  }
</script>

<style scoped>
  .date-item{
    display: inline-block;
    line-height: 32px;
    text-align: center;
    padding: 0 14px;
    border: #9C9A9B solid 1px;
    background: #fff;
    margin-right: 8px;
    cursor: pointer;
    margin-bottom: 10px;
    color: #999999;
    font-weight: 600;
  }
  .date-on{
    animation: changeTab .3s forwards;
  }
  .date-disable{
    cursor: not-allowed;
    background: #ffffff;
    color: #D3D3D3;
    border-style: dashed;
  }

  @keyframes changeTab {
    from {background: #fff; border-color: #9C9A9B; color: #000;}
    to {background: #575757; border-color: #575757; color: #fff;}
  }
</style>
